"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _parseCssValue = require("../../utils/parseCssValue");
var _rtl = require("../../utils/vars/rtl");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
// if there's anything set related to border
// but not the style, we set it to solid
var helpWithBorder = function helpWithBorder(object) {
  if (object.border || object.borderStyle) {
    return object;
  }
  if (object.borderWidth || object.borderColor) {
    object.borderStyle = "solid";
  }
  return object;
};
var extendKeys = function extendKeys(keys) {
  if (!keys) {
    return [];
  }
  var extendedKeys = _toConsumableArray(keys);
  if (keys.includes("margin")) {
    extendedKeys.push("marginTop", "marginRight", "marginBottom", "marginLeft");
  }
  if (keys.includes("padding")) {
    extendedKeys.push("paddingTop", "paddingRight", "paddingBottom", "paddingLeft");
  }
  return extendedKeys;
};

/**
 * Initializes helper functions to handle dynamic props
 */
var initVars = function initVars(_ref) {
  var _variables$map;
  var variables = _ref.variables,
    applied = _ref.applied;
  var extendedApplied = extendKeys(applied);
  var keys = [].concat(_toConsumableArray((_variables$map = variables === null || variables === void 0 ? void 0 : variables.map(function (variable) {
    return variable.key;
  })) !== null && _variables$map !== void 0 ? _variables$map : []), _toConsumableArray(extendedApplied));
  var getDependencyArray = function getDependencyArray(params) {
    if (!params) {
      return [];
    }
    return keys.map(function (key) {
      return params[key];
    });
  };
  var useVars = function useVars(params) {
    return (0, _react.useMemo)(function () {
      return params;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    getDependencyArray(params));
  };
  var getVariableValue = function getVariableValue(value, key) {
    if (!variables) {
      return undefined;
    }
    var variableKeys = variables.map(function (variable) {
      return variable.key;
    });
    if (!variableKeys.includes(key)) {
      return undefined;
    }
    var options = variables.find(function (variable) {
      return variable.key === key;
    });
    return (0, _parseCssValue.parseCssValue)(value, options);
  };
  var styles = function styles(params) {
    if (!params) {
      return {};
    }
    params = (0, _rtl.splitRtlProps)(params);
    var mapped = Object.entries(params).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      if (extendedApplied.includes(key)) {
        return [(0, _rtl.makeKeyRtlSafe)(key), (0, _parseCssValue.parseCssValue)(value, key)];
      }
      var cssValue = getVariableValue(value, key);
      if (cssValue) {
        return ["--".concat(key), cssValue];
      }
      return [];
    })
    // filters out empty arrays and invalid values
    .filter(function (item) {
      return typeof item[1] !== "undefined";
    });
    var object = Object.fromEntries(mapped);
    return helpWithBorder(object);
  };
  var get = function get(key, fallback) {
    if (typeof fallback !== "undefined") {
      var value = getVariableValue(fallback, key);
      if (value) {
        return "var(--".concat(String(key), ", ").concat(value, ")");
      }
    }
    return "var(--".concat(String(key), ")");
  };
  return {
    useVars: useVars,
    styles: styles,
    get: get
  };
};
var _default = exports.default = initVars;
/**
 * Type helpers
 */